export const USER_TYPE_FIELD_CODE = "UserType";
export const OPERATION_FIELD_CODE = "Operation";
export const SYNTHETIC_RULE_FIELD_CODES = [USER_TYPE_FIELD_CODE, OPERATION_FIELD_CODE];
